// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Edit from '../components/User/Profile/Edit';
import { Redirect } from 'react-router';

@inject('userStore')
@observer class ProfileRoute extends Component<any, any> {
	render() {
		if(this.props.userStore.user) {
			return (
				<Edit key={this.props.userStore.user.id} />
			)
		} else {
			return (<Redirect to="/?login=true" />)
		}
	}
}

export default ProfileRoute;

